import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { Button, ControlLabel } from 'react-bootstrap';
import { Creatable } from 'react-select';
import cx from 'classnames';
import * as docketActions from '../../../../redux/actions/docketActions';

const hasError = meta => meta.error && meta.submitFailed;

class EmailForm extends Component {
  componentDidMount() {
    this.props.dispatch(docketActions.loadFavoriteEmails());
    this.props.dispatch(docketActions.loadLastFavoriteEmails());
  }

  onSubmit = ({ emails, message }) => {
    this.props.onSendEmail({
      emails: emails.map(e => e.value),
      message,
    });
  };

  getSubmitButtonContent = () => {
    if (this.props.popup.isEmailSending) {
      return (
        <Fragment>
          <i className="fa fa-envelope" />
          &nbsp; Sending...
        </Fragment>
      );
    }
    if (this.props.popup.isEmailSending === false) {
      return (
        <Fragment>
          <i className="fa fa-check" />
          &nbsp; Email Sent
        </Fragment>
      );
    }
    return (
      <Fragment>
        <i className="fa fa-envelope" />
        &nbsp; Send Email
      </Fragment>
    );
  };

  render() {
    const isLoading = this.props.favoriteEmails.status === 'loading';
    const options = this.props.favoriteEmails.emails.map(email => ({ value: email, label: email }));

    return (
      <Form
        initialValues={{
          emails: this.props.favoriteEmails.lastRecipients.map(email => ({ value: email, label: email })),
        }}
        validate={values => {
          const errors = {};
          if (values.emails.length === 0) {
            errors.emails = 'Email To is required';
          }
          const invalidEmail = values.emails.find(email => !/\S+@\S+\.\S+/.test(email.value));

          if (invalidEmail) {
            errors.emails = `${invalidEmail.value} doesn't look like a valid email`;
          }
          return errors;
        }}
        onSubmit={this.onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div>
              <Field name="emails">
                {({ input, meta }) => {
                  return (
                    <div>
                      <ControlLabel>Email To (separate with commas)</ControlLabel>
                      <Creatable
                        {...input}
                        name="emails"
                        isLoading={isLoading}
                        multi
                        options={options}
                        className={cx({ error: hasError(meta) })}
                      />
                      {hasError(meta) && <span className="error description">{meta.error}</span>}
                    </div>
                  );
                }}
              </Field>
              <div style={{ paddingRight: '26px' }}>
                <ControlLabel htmlFor="message">Message (optional)</ControlLabel>
                <Field name="message" className="form-control" component="textarea" rows="5" cols="35" />
              </div>
            </div>

            {this.props.children}

            <div className="bg-color-grey footer-btn">
              <Button type="button" onClick={this.props.onCancel}>
                Cancel
              </Button>
              <Button
                type="submit"
                className="pull-right"
                bsStyle="primary"
                disabled={!this.props.canSend || this.props.popup.isEmailSending !== undefined}
                title={this.props.sendButtonHint}
              >
                {this.getSubmitButtonContent()}
              </Button>
            </div>
          </form>
        )}
      />
    );
  }
}

EmailForm.defaultProps = {
  children: null,
};

EmailForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  favoriteEmails: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  onSendEmail: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  canSend: PropTypes.bool.isRequired,
  sendButtonHint: PropTypes.string.isRequired,
  children: PropTypes.any,
};

const mapStateToProps = state => {
  const { favoriteEmails, popup, docketParts } = state.get('dockets').toJS();

  return {
    favoriteEmails,
    popup,
    docketParts,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailForm);



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/EmailForm.jsx